import type { ArchivoRecord } from '@/otros-tramites/types';
import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  archivo: ArchivoRecord;
};

const WhatsAppOtroTramiteArchivoModal = ({
  open,
  onOpenChange,
  tramite,
  archivo,
}: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      eventType="otros_tramites.envio_archivo"
      title="Enviar archivo por WhatsApp"
      description="Se enviará el archivo con enlace temporal seguro."
      contextOverrides={{
        otro_tramite_id: tramite.id,
        tramite_id: tramite.id,
        archivo_id: archivo.id,
      }}
    />
  );
};

export default WhatsAppOtroTramiteArchivoModal;
